var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coupon-list"},_vm._l((_vm.coupons),function(coupon){return _c('CouponItem',{key:coupon.couponId,attrs:{"coupon":coupon},on:{"receivedCoupon":_vm.receivedCoupon}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }